import { toast } from "react-toastify";

export const errorHandler = (err: any): { data?: any; error: any; } => {
	const error = err.response.data.message ||  err.response.data.error;
	toast.error(error);
	return { error };
}
